import { Link } from '@/router';
import { NAV, SIGNATURES, SITE } from '@/data/site';
import { GonjongMark, SongketDivider } from '@/components/Motifs';

export default function Footer() {
  return (
    <footer className="bg-charcoal text-stone-300 texture-grain" data-testid="site-footer">
      <SongketDivider light />
      <div className="mx-auto grid max-w-6xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr] md:py-20">
        <div>
          <div className="flex items-center gap-3 text-turmeric">
            <GonjongMark className="h-10 w-10" />
            <span className="leading-tight">
              <span className="block text-[10px] font-semibold uppercase tracking-[0.28em] text-stone-400">Nasi Padang</span>
              <span className="block font-display text-2xl font-bold text-santan">Sederhana</span>
            </span>
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-stone-400">
            {SITE.description}
          </p>
        </div>
        <nav aria-label="Tautan jelajah">
          <h2 className="text-xs font-bold uppercase tracking-[0.24em] text-turmeric">Jelajahi</h2>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  data-testid={`footer-${n.label.toLowerCase().replace(/\s+/g, '-')}-link`}
                  className="text-sm font-medium text-stone-300 transition-colors duration-200 hover:text-turmeric"
                >
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <h2 className="text-xs font-bold uppercase tracking-[0.24em] text-turmeric">Hidangan Khas</h2>
          <ul className="mt-5 space-y-3">
            {SIGNATURES.map((s) => (
              <li key={s.slug}>
                <Link
                  to="/menu/"
                  data-testid={`footer-dish-${s.slug}-link`}
                  className="text-sm font-medium text-stone-300 transition-colors duration-200 hover:text-turmeric"
                >
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-4 py-6 text-xs text-stone-500 sm:px-6 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} {SITE.name} · Masakan Minangkabau</p>
          <p>{SITE.domain.replace('https://', '')}</p>
        </div>
      </div>
    </footer>
  );
}
